import { useInfiniteQuery } from '@tanstack/react-query'
import { userHostTaskSpecialWeekendService } from '../../../../services/users-tasks/users-hosts-tasks-specials-weekends'
import type { GetList } from '../../../../services/users-tasks/users-hosts-tasks-specials-weekends/types'

export const USERS_HOSTS_TASKS_SPECIALS_WEEKENDS_QUERY_KEY =
  'getUsersHostsTasksSpecialsWeekends'

export const useGetUsersHostsTasksSpecialsWeekends = (
  params: GetList.Input,
) => {
  const { data, isFetchingNextPage, isLoading, refetch, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [USERS_HOSTS_TASKS_SPECIALS_WEEKENDS_QUERY_KEY, params],
      initialPageParam: 0,
      queryFn: ({ pageParam: skip }) => {
        return userHostTaskSpecialWeekendService.getList({
          take: 20,
          skip,
          ...params,
        })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  return {
    usersHostsTasksSpecialsWeekends: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
  }
}
